import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImportStatisticsPanel from "./ImportStatisticsPanel";

const ISSUE_TEXT_COLORS = {
  error: "#8b1a1a",
  warning: "#8a6d00",
};

const formatLabel = (input) => {
  if (!input) return "";
  return input
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const formatRowIndex = (rowIndex) => {
  if (rowIndex == null || rowIndex === "") {
    return "Generale";
  }
  return rowIndex;
};

const DialogDettaglioImportazione = ({
  open,
  onClose,
  statistics,
  issues,
  isLoading,
  loadError,
}) => {
  const hasIssues = Array.isArray(issues) && issues.length > 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3 },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}
        >
          Dettagli importazione
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        ) : loadError ? (
          <Typography
            sx={{ fontFamily: "Rubik", color: "#808080", textAlign: "center", py: 3 }}
          >
            {loadError}
          </Typography>
        ) : (
          <>
            <ImportStatisticsPanel statistics={statistics} />

            {hasIssues ? (
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Rubik",
                    fontWeight: "bold",
                    color: "#0b3d87",
                    mb: 1.5,
                  }}
                >
                  Errori e avvisi
                </Typography>
                <Table sx={{ tableLayout: "fixed", width: "100%" }}>
                  <TableHead sx={{ backgroundColor: "#003366" }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontFamily: "Rubik",
                          color: "white",
                          fontWeight: "bold",
                          width: "25%",
                        }}
                      >
                        Numero riga
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "Rubik",
                          color: "white",
                          fontWeight: "bold",
                          width: "75%",
                        }}
                      >
                        Dettaglio
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {issues.map((row, index) => {
                      const issueType = row.issueType === "warning" ? "warning" : "error";
                      const detailColor = ISSUE_TEXT_COLORS[issueType];
                      return (
                        <TableRow
                          key={row.uuidRow ?? `${row.rowIndex}-${issueType}-${index}`}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#f0f5ff" : "white",
                          }}
                        >
                          <TableCell
                            sx={{
                              fontFamily: "Rubik",
                              fontWeight: "bold",
                              color: "#0b3d87",
                            }}
                          >
                            {formatRowIndex(row.rowIndex)}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily: "Rubik",
                              fontWeight: "bold",
                              color: detailColor,
                            }}
                          >
                            {formatLabel(row.colonneErrori) ?? ""}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            ) : null}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DialogDettaglioImportazione;
